import { styled } from "@mui/material/styles";
import WorkAgreement from "work/work-agreements/work-agreement";

const ComponentContainer = styled("div")(
  ({ theme }) => ({
    margin: theme.spacing(2, 0, 4, 0),
  }));

type InvoicesTabProps = {
  workAgreement: WorkAgreement;
};

export default function InvoicesTab(props: Readonly<InvoicesTabProps>) {
  const {
    workAgreement
  } = props;

  return (
    <ComponentContainer>
      {workAgreement.name?.value} - Invoices Tab
      <br />
      <p>TODO</p>
    </ComponentContainer>
  );
}
